import type { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";

interface PageShellProps extends PropsWithChildren {
  className?: string;
}

export const PageShell = ({ children, className }: PageShellProps) => {
  return (
    <div
      className={cn(
        "flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pt-4 pb-[calc(5rem+env(safe-area-inset-bottom,0px))] sm:px-5 lg:px-6 lg:pb-4",
        className,
      )}
    >
      {children}
    </div>
  );
};

